import React, { useState } from "react";
import "../styles/ClubPage.css";

const AccordionSection = ({ title, children, isOpen, onToggle }) => (
    <div className="accordion-section">
        <h3
            onClick={onToggle}
            style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
        >
            {title}
            <span>{isOpen ? "−" : "+"}</span>
        </h3>
        {isOpen && <div className="accordion-content">{children}</div>}
    </div>
);

const ClubAbout = ({ clubData }) => {
    const [openSection, setOpenSection] = useState(null); // only one section at a time

    const toggleSection = (key) => {
        setOpenSection(openSection === key ? null : key);
    };

    if (!clubData) return <p>Loading club information...</p>;

    return (
        <div className="club-about">
            <h2>About the Club</h2>
            <p>{clubData.description}</p>

            {clubData.objective && (
                <AccordionSection
                    title="🎯 Objective"
                    isOpen={openSection === "objective"}
                    onToggle={() => toggleSection("objective")}
                >
                    <ul>
                        {clubData.objective.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </AccordionSection>
            )}

            {clubData.mission && (
                <AccordionSection
                    title="🌟 Mission"
                    isOpen={openSection === "mission"}
                    onToggle={() => toggleSection("mission")}
                >
                    <ul>
                        {clubData.mission.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </AccordionSection>
            )}

            {clubData.vision && (
                <AccordionSection
                    title="🚀 Vision"
                    isOpen={openSection === "vision"}
                    onToggle={() => toggleSection("vision")}
                >
                    <p>{clubData.vision}</p>
                </AccordionSection>
            )}

            {clubData.values && (
                <AccordionSection
                    title="💡 Core Values"
                    isOpen={openSection === "values"}
                    onToggle={() => toggleSection("values")}
                >
                    <ul>
                        {clubData.values.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </AccordionSection>
            )}
        </div>
    );
};

export default ClubAbout;
